import {
	primaryColor,
	blackColors,
	successColor,
	dangerColor,
	whiteColor,
} from 'assets/jss/material-dashboard-pro-react';

const registeringComplaintStyle = (theme) => ({
	registerTicketNumberInfo: {
		background: '#FAFAFA',
		borderRadius: 8,
		textAlign: 'left',
		padding: 16,
		margin: 'auto',
		maxWidth: 300,
		'& > div': {
			margin: '8px 0',
			'&:last-of-type': {
				marginBottom: 0,
			},
		},
	},
	divider: {
		width: '100%',
		height: '1px',
		backgroundColor: 'rgba(0, 0, 0, 0.24)',
		margin: '16px 0!important',
	},
	inputIcon: {
		padding: 0,
		backgroundColor: 'transparent!important',
		'& svg': {
			width: 14,
			height: 14,
		},
	},
	doneInputIcon: {
		'& svg': {
			fill: primaryColor[0],
		},
	},
	suggestionsWrapper: {
		background: whiteColor,
		boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
		borderRadius: 8,
		width: '100%',
		padding: '7px 0',
		position: 'absolute',
		top: 62,
	},
	singleSuggestionWrapper: {
		padding: '11px 16px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'pointer',
		transition: 'all .1s ease-in-out',
		'& svg': {
			width: 16,
			height: 16,
			color: primaryColor[0],
			transform: `scaleX(${theme.language === 'ar' ? -1 : 1})`,
		},
	},
	noResultsWrapper: {
		padding: '11px 16px',
		display: 'flex',
		justifyContent: 'flex-start',
	},
	activeSingleSuggestionWrapper: {
		backgroundColor: '#d7e6f3',
	},
	dropdownWrapper: {
		position: 'relative',
		zIndex: 10,
		'& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
			'-webkit-appearance': 'none',
			margin: 0,
		},
		'& input[type=number]': {
			'-moz-appearance': 'textfield',
		},
	},
	registerTicketSingleTabWrapper: {
		textAlign: 'center',
		padding: '25px 0 48px 0',
		maxWidth: 300,
		margin: 'auto',
		[theme.breakpoints.down('xs')]: {
			padding: '25px 0 41px 0',
		},
	},
	registerTicketSelectedSingleTabWrapper: {
		paddingTop: 20,
		textAlign: 'auto',
	},
	registerTicketInputWrapper: {
		maxWidth: 208,
		margin: 'auto',
	},
	registerTicketInputSelectedWrapper: {
		marginLeft: 0,
	},
	messageWrapper: {
		borderRadius: 8,
		border: `solid 1px ${blackColors[3]}`,
		marginTop: 13,
		padding: 16,
	},
	formButtonContainer: {
		textAlign: 'right',
		paddingTop: 27,
	},
	contactNumberInfoRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
		'& svg': {
			width: 16,
			height: 16,
			color: blackColors[4],
			marginRight: 8,
		},
	},
	selectWrapper: {
		textAlign: 'left',
	},
	select: {
		'& > label': {
			fontSize: 16,
			'&.MuiInputLabel-shrink': {
				fontSize: '14px!important',
			},
		},
		'& .MuiInput-input': {
			fontSize: 16,
		},
	},
	loaderWrapper: {
		position: 'absolute',
		zIndex: 100,
		height: '100%',
		width: '100%',
		borderRadius: 8,
		'& > div': {
			height: '100%',
		},
	},
	cardBody: {
		padding: 0,
		minHeight: '304px',
	},
	responseCardBody: {
		minHeight: 'auto',
	},
	cardBodyContentWrapper: {
		padding: 24,
	},
	responseWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		padding: '24px 0',
	},
	oval: {
		width: 56,
		height: 56,
		borderRadius: '100%',
		position: 'relative',
		marginBottom: 24,
		marginLeft: 'auto',
		marginRight: 'auto',
		'& > *': {
			width: 38,
			height: 38,
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)',
			justifyContent: 'center',
			display: 'flex',
			alignItems: 'center',
			fontSize: 30,
		},
	},
	ovalSuccess: {
		border: `solid 3px ${successColor[0]}`,
		color: successColor[0],
	},
	ovalError: {
		border: `solid 3px ${dangerColor[0]}`,
		color: dangerColor[0],
	},
	ticketRegisteredWrapper: {
		maxWidth: 300,
		paddingTop: 12,
		paddingBottom: 25,
		textAlign: 'center',
	},
	followTicketStatusWrapper: {
		maxWidth: 295,
		textAlign: 'center',
	},
	newMessageButton: {
		marginTop: 20,
	},
	registerTicketOthersSingleTabWrapper: {
		paddingTop: 20,
	},
	registerTicketFailureMessageWrapper: {
		maxWidth: 300,
		textAlign: 'center',
		paddingTop: 12,
	},
});

export default registeringComplaintStyle;
